import { render, staticRenderFns } from "./ProjectsGantt.vue?vue&type=template&id=354044eb&"
import script from "./ProjectsGantt.vue?vue&type=script&lang=js&"
export * from "./ProjectsGantt.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsGantt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports